import { useContext, useEffect, useRef, useState } from "react";
import { Language, Sponsorpost } from "../../../App";
import { Carousel } from "react-responsive-carousel";
import { useNavigate } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { MdOutlineCampaign } from "react-icons/md";
import { LOGIN, NEW_CONTEST } from "../../../constants/RoutesUrl";
import axios from "axios";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { MedicalQuizContest } from "../../sponsor-post/MedicalQuizContest";
import { _imagesURL, adminBaseURL } from "../../../constants/API";

/* slide: clean image, no overlays */
function SpSlide({ src, height, isClickable, onClick }) {
  return (
    <div
      style={{
        width: "100%",
        height: `${height}px`,
        overflow: "hidden",
        cursor: isClickable ? "pointer" : "default",
        background: "#EDF2F7",
        flexShrink: 0,
      }}
      onClick={isClickable ? onClick : undefined}
    >
      <img
        src={src}
        alt="Sponsored"
        style={{ width: "100%", height: "100%", objectFit: "cover", display: "block" }}
        onError={(e) => { e.target.style.opacity = "0"; }}
      />
    </div>
  );
}

export default function FeedSponsorPost({ new_contest_obj = [], loading }) {
  const { lang } = useContext(Language);
  const { updateContext } = useContext(Sponsorpost);
  const [showMedicalQuiz, setShowMedicalQuiz] = useState(false);
  const [medicalMedia, setMedicalMedia] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [cardWidth, setCardWidth] = useState(0);
  const { data } = JSON.parse(localStorage.getItem("SignupData"));
  const colRef = useRef();
  const carouselRef = useRef();
  const Redirect = useNavigate();

  useEffect(() => {
    if (!colRef.current) return undefined;
    const update = () => setCardWidth(colRef.current?.clientWidth || 0);
    const ro = new ResizeObserver(update);
    update();
    ro.observe(colRef.current);
    return () => ro.disconnect();
  }, []);

  useEffect(() => {
    const contestData = new_contest_obj.find(c => c.name === "contest_5");
    setMedicalMedia(contestData);
  }, [new_contest_obj]);

  function handleRedirect(ad) {
    switch (ad.internal_model) {
      case "course": Redirect(`/course-detail/${ad.course_id}`); break;
      case "profile": Redirect(`/profile/${ad.user_id}`); break;
      case "clinical_session": Redirect(`/session-details/${ad.post_id}`); break;
      case "webinar": Redirect(`/webinar-details/${ad.post_id}`); break;
      case "clinical_study": Redirect(`/post/${ad.post_id}`); break;
      case "event": Redirect(`/event-details/${ad.event_id}`); break;
      default: console.warn("Unknown internal_model:", ad.internal_model);
    }
  }

  const handleAdClick = async (ad) => {
    if (ad.type === "external") {
      window.open(ad.link, "_blank");
      return;
    } else if (ad.type === "internal") {
      handleRedirect(ad);
    } else {
      Redirect(NEW_CONTEST, { state: { dynamicAd: ad } });
    }
    updateContext(ad);
    if (data?.token) {
      try {
        await axios.post(
          `${adminBaseURL}user/ads/view`,
          { device: "Web", ad_id: ad.id, type: "view" },
          { headers: { Authorization: `Bearer ${data.token}` } }
        );
      } catch (err) { console.error("Ad click error:", err); }
    } else {
      Redirect(LOGIN);
    }
  };

  const handleSlideChange = async (idx) => {
    setCurrentSlide(idx);
    const ad = new_contest_obj[idx];
    if (!ad || !data?.token) return;
    try {
      await axios.post(
        `${adminBaseURL}user/ads/view`,
        { device: "Web", ad_id: ad.id, type: "impression" },
        { headers: { Authorization: `Bearer ${data.token}` } }
      );
    } catch (err) { console.error("Impression error:", err); }
  };

  const totalSlides = new_contest_obj.length;

  const css = `
    @keyframes spShimmer { 0% { background-position:200% 0; } 100% { background-position:-200% 0; } }
    .sp-sh { background:linear-gradient(90deg,#F1F5F9 0%,#E2E8F0 50%,#F1F5F9 100%); background-size:200% 100%; animation:spShimmer 1.6s ease-in-out infinite; }
    .sp-card { border-radius:20px; border:1px solid #EBF1F6; background:#FFFFFF; box-shadow:0 2px 12px rgba(11,19,43,.05); overflow:hidden; font-family:'Onest',sans-serif; transition:box-shadow .28s ease,border-color .28s ease; }
    .sp-card:hover { box-shadow:0 6px 22px rgba(11,19,43,.09); border-color:rgba(0,186,218,.28); }
    .sp-header { display:flex; justify-content:space-between; align-items:center; padding:10px 14px; border-bottom:1px solid #F1F5F9; background:#FFFFFF; }
    .sp-bottom-bar { display:flex; justify-content:space-between; align-items:center; padding:7px 12px; border-top:1px solid #F1F5F9; background:#FFFFFF; }
    .sp-nav-btn { width:28px; height:28px; border-radius:50%; border:1px solid #E2E8F0; background:#F8FAFC; color:#64748B; display:flex; align-items:center; justify-content:center; cursor:pointer; padding:0; line-height:0; transition:all .18s ease; outline:none; flex-shrink:0; }
    .sp-nav-btn svg { display:block; }
    .sp-nav-btn:hover { background:linear-gradient(135deg,#00C8E8 0%,#00BADA 100%); border-color:transparent; color:#FFFFFF; box-shadow:0 3px 10px rgba(0,186,218,.38); transform:scale(1.07); }
    .sp-dot { height:5px; border-radius:999px; transition:all .28s cubic-bezier(.4,0,.2,1); cursor:pointer; }
    .sp-card .carousel-root,.sp-card .carousel,.sp-card .carousel.carousel-slider,.sp-card .slider-wrapper,.sp-card .slider { width:100%; }
    .sp-card .carousel .slide { background:transparent; padding:0; margin:0; }
    .sp-card .carousel ul { padding:0; margin:0; }
  `;

  if (loading) {
    return (
      <div className="sp-card mb-3" ref={colRef}>
        <style>{css}</style>
        <div className="sp-header">
          <div className="d-flex align-items-center gap-2">
            <div className="sp-sh rounded-circle" style={{ width: 26, height: 26 }} />
            <div className="sp-sh" style={{ width: 110, height: 12, borderRadius: 6 }} />
          </div>
          <div className="sp-sh" style={{ width: 72, height: 20, borderRadius: 999 }} />
        </div>
        <div className="sp-sh" style={{ width: "100%", height: 180 }} />
        <div className="sp-bottom-bar">
          <div className="sp-sh" style={{ width: 28, height: 28, borderRadius: "50%" }} />
          <div className="d-flex gap-2 align-items-center">
            {[0, 1, 2].map(i => <div key={i} className="sp-sh sp-dot" style={{ width: i === 1 ? 18 : 6 }} />)}
          </div>
          <div className="sp-sh" style={{ width: 28, height: 28, borderRadius: "50%" }} />
        </div>
      </div>
    );
  }

  if (!new_contest_obj || new_contest_obj.length === 0) return null;

  return (
    <>
      <style>{css}</style>

      <div className="sp-card mb-3" ref={colRef}>

        {/* 1. HEADER — above image, not overlaid */}
        <div className="sp-header">
          <div className="d-flex align-items-center gap-2">
            <div
              className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ width: 26, height: 26, background: "#E8FBFF", color: "#00BADA", border: "1px solid #BAE8F8" }}
            >
              <MdOutlineCampaign size={14} />
            </div>
            <span style={{ fontSize: 13, fontWeight: 600, color: "#0F1A2B", fontFamily: "'Onest',sans-serif", lineHeight: 1 }}>
              {lang?.advertisement || "Advertisement"}
            </span>
          </div>
          <span
            className="badge rounded-pill"
            style={{ fontSize: 10, fontWeight: 700, background: "#E8FBFF", color: "#00BADA", border: "1px solid #BAE8F8", padding: "3px 10px", letterSpacing: ".4px" }}
          >
            SPONSORED
          </span>
        </div>

        {/* 2. IMAGE CAROUSEL — all slides use first slide's ratio for consistent height */}
        {(() => {
          // compute height once from the first slide so every slide is the same
          const firstData = new_contest_obj[0]?.general_ad || new_contest_obj[0];
          const firstMediaSize = Number(firstData?.media_size);
          const sharedMediaSize = firstMediaSize > 0 ? firstMediaSize : 1.5;
          const sharedHeight = Math.round((cardWidth || 335) / sharedMediaSize);

          return (
            <Carousel
              ref={carouselRef}
              onChange={handleSlideChange}
              autoPlay={totalSlides > 1}
              interval={4500}
              infiniteLoop={totalSlides > 1}
              showIndicators={false}
              showThumbs={false}
              showArrows={false}
              showStatus={false}
              selectedItem={currentSlide}
              swipeable={totalSlides > 1}
              emulateTouch={totalSlides > 1}
            >
              {new_contest_obj.map((contest, index) => {
                const contestData = contest?.general_ad || contest;
                const mediaSrc = contestData?.media
                  ? (contestData.media.startsWith("http") ? contestData.media : `${_imagesURL}${contestData.media}`)
                  : "";
                return (
                  <SpSlide
                    key={contest.id || index}
                    src={mediaSrc}
                    height={sharedHeight}
                    isClickable={Boolean(contestData?.type)}
                    onClick={() => handleAdClick(contestData)}
                  />
                );
              })}
            </Carousel>
          );
        })()}

        {/* 3. BOTTOM NAV — below image, not overlaid */}
        {totalSlides > 1 && (
          <div className="sp-bottom-bar">
            <button type="button" className="sp-nav-btn" aria-label="Previous ad"
              onClick={(e) => { e.stopPropagation(); carouselRef.current?.moveTo(currentSlide === 0 ? totalSlides - 1 : currentSlide - 1); }}
            >
              <FiChevronLeft size={14} strokeWidth={2.5} />
            </button>

            <div className="d-flex align-items-center gap-2">
              {totalSlides <= 8 ? (
                new_contest_obj.map((_, idx) => (
                  <div key={idx} className="sp-dot"
                    style={{ width: idx === currentSlide ? "18px" : "6px", background: idx === currentSlide ? "#00BADA" : "#D0DDE8" }}
                    onClick={() => carouselRef.current?.moveTo(idx)}
                  />
                ))
              ) : (
                <span style={{ fontSize: 12, fontWeight: 700, color: "#00BADA" }}>{currentSlide + 1} / {totalSlides}</span>
              )}
            </div>

            <button type="button" className="sp-nav-btn" aria-label="Next ad"
              onClick={(e) => { e.stopPropagation(); carouselRef.current?.moveTo(currentSlide === totalSlides - 1 ? 0 : currentSlide + 1); }}
            >
              <FiChevronRight size={14} strokeWidth={2.5} />
            </button>
          </div>
        )}
      </div>

      {showMedicalQuiz && (
        <MedicalQuizContest
          contestMedia={medicalMedia.media}
          showMedicalQuiz={showMedicalQuiz}
          toggle={() => setShowMedicalQuiz(!showMedicalQuiz)}
        />
      )}
    </>
  );
}
